import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TerminationRequest } from '../../model/termination-request';

@Component({
  selector: 'app-view-termination-dialog',
  templateUrl: './view-termination-dialog.component.html',
  styleUrl: './view-termination-dialog.component.scss'
})
export class ViewTerminationDialogComponent {

  /**
   * Default constructor initializes the component with a dialog ref
   * @param dialogRef
   * @param data
   */
  constructor(
    public dialogRef: MatDialogRef<ViewTerminationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { terminationRecord: TerminationRequest }
  ) {}

  /**
   * Close the dialog
   */
  public close(): void {
    this.dialogRef.close();
  }
}
